import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyIT() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Torna all'app
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Informativa sulla Privacy</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Titolare del Trattamento dei Dati</h2>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Il titolare del trattamento è:</strong>
                </p>
                <div className="ml-4 space-y-1">
                  <p><strong>Nome:</strong> Puretech s.r.o.</p>
                  <p><strong>Numero di registrazione:</strong> 05503795</p>
                  <p><strong>Sede:</strong> Repubblica Ceca</p>
                  <p><strong>Contatto:</strong> support@simplestickers.app</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informazioni che Raccogliamo</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Informazioni dell'account:</strong> Quando crei un account, raccogliamo il tuo indirizzo email e qualsiasi informazione del profilo che scegli di fornire.
                </p>
                <p className="leading-relaxed">
                  <strong>Dati di utilizzo:</strong> Raccogliamo informazioni su come utilizzi il nostro servizio, incluse le attività create, i progetti gestiti e i modelli di utilizzo delle funzionalità.
                </p>
                <p className="leading-relaxed">
                  <strong>Informazioni di pagamento:</strong> L'elaborazione dei pagamenti è gestita da Polar. Non memorizziamo i dettagli della tua carta di pagamento sui nostri server.
                </p>
                <p className="leading-relaxed">
                  <strong>Dati tecnici:</strong> Raccogliamo automaticamente alcune informazioni tecniche, inclusi indirizzo IP, tipo di browser, sistema operativo e informazioni sul dispositivo.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Come Utilizziamo le Tue Informazioni</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Utilizziamo le informazioni che raccogliamo per:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Fornire, mantenere e migliorare i nostri servizi</li>
                  <li>Elaborare transazioni e gestire abbonamenti</li>
                  <li>Inviarti notifiche tecniche e messaggi di supporto</li>
                  <li>Rispondere ai tuoi commenti e domande</li>
                  <li>Analizzare i modelli di utilizzo per migliorare l'esperienza utente</li>
                  <li>Far rispettare i nostri termini e condizioni</li>
                  <li>Rispettare gli obblighi legali</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Condivisione delle Informazioni</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Non vendiamo, scambiamo o trasferiamo le tue informazioni personali a terze parti, tranne come descritto in questa politica:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Fornitori di servizi:</strong> Possiamo condividere informazioni con terze parti fidate che ci assistono nel funzionamento del nostro servizio (ad es. Polar per l'elaborazione dei pagamenti, Supabase per i servizi di database)</li>
                  <li><strong>Requisiti legali:</strong> Possiamo divulgare informazioni quando richiesto dalla legge o per proteggere i nostri diritti</li>
                  <li><strong>Trasferimenti aziendali:</strong> In caso di fusione, acquisizione o vendita di asset, le informazioni degli utenti possono essere trasferite</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Sicurezza dei Dati</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Implementiamo misure di sicurezza tecniche e organizzative appropriate per proteggere le tue informazioni personali da accesso non autorizzato, alterazione, divulgazione o distruzione. Tuttavia, nessun metodo di trasmissione su Internet è sicuro al 100%.
                </p>
                <p className="leading-relaxed">
                  <strong>Risposta alle violazioni della sicurezza:</strong> In caso di violazione dei dati personali, rispetteremo il GDPR:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Segnalare l'incidente all'autorità di controllo entro 72 ore dalla scoperta</li>
                  <li>Notificare gli utenti interessati se la violazione presenta un rischio elevato per i loro diritti e libertà</li>
                  <li>Adottare misure per ridurre al minimo l'impatto e prevenire incidenti futuri</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Conservazione dei Dati</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Conserviamo le tue informazioni personali per il tempo necessario a fornire i nostri servizi. I periodi di conservazione specifici sono:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Dati dell'account:</strong> Durata del servizio + 30 giorni dopo l'eliminazione dell'account</li>
                  <li><strong>Contenuto delle attività (note adesive):</strong> Fino a quando non le elimini o chiudi l'account</li>
                  <li><strong>Registrazioni di pagamento:</strong> 7 anni (requisito della legge contabile ceca)</li>
                  <li><strong>Dati analitici:</strong> Fino a 26 mesi</li>
                  <li><strong>Dati di backup:</strong> Possono persistere fino a 90 giorni dopo l'eliminazione primaria</li>
                  <li><strong>Dati anonimizzati:</strong> Conservati indefinitamente per scopi statistici</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. I Tuoi Diritti ai Sensi del GDPR</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Hai il diritto di:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Accedere alle informazioni personali che deteniamo su di te</li>
                  <li>Correggere eventuali informazioni personali inesatte</li>
                  <li>Richiedere la cancellazione delle tue informazioni personali</li>
                  <li>Opporti o limitare il trattamento delle tue informazioni</li>
                  <li>Portabilità dei dati (ricevere una copia dei tuoi dati in formato strutturato)</li>
                  <li>Revocare il consenso in qualsiasi momento</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Cookie e Tracciamento</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Utilizziamo cookie e tecnologie di tracciamento simili per migliorare la tua esperienza. Tipi di cookie che utilizziamo:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Cookie essenziali:</strong> Necessari per la funzionalità del servizio (autenticazione, accesso)</li>
                  <li><strong>Cookie analitici:</strong> Ci aiutano a capire come utilizzi il nostro servizio (puoi rifiutare)</li>
                  <li><strong>Cookie di terze parti:</strong> Google OAuth, Polar per i pagamenti</li>
                </ul>
                <p className="leading-relaxed">
                  Puoi controllare le impostazioni dei cookie attraverso le preferenze del tuo browser o il nostro banner dei cookie alla prima visita.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Servizi di Terze Parti</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">Il nostro servizio si integra con servizi di terze parti:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Google OAuth:</strong> Per l'autenticazione (soggetto alla politica sulla privacy di Google)</li>
                  <li><strong>Polar:</strong> Per l'elaborazione dei pagamenti (soggetto alla politica sulla privacy di Polar)</li>
                  <li><strong>Supabase:</strong> Per servizi di database e autenticazione</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Privacy dei Bambini</h2>
              <p className="leading-relaxed">
                Il nostro servizio non è destinato a bambini di età inferiore a 16 anni. Non raccogliamo consapevolmente informazioni personali da bambini di età inferiore a 16 anni. Se sei un genitore o tutore e ritieni che tuo figlio ci abbia fornito informazioni personali, ti preghiamo di contattarci all'indirizzo support@simplestickers.app.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Trasferimenti Internazionali di Dati</h2>
              <p className="leading-relaxed">
                Le tue informazioni possono essere trasferite ed elaborate in paesi diversi dal tuo paese di residenza. Garantiamo che siano in atto garanzie appropriate per proteggere le tue informazioni personali in conformità con le leggi applicabili sulla protezione dei dati.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Modifiche a Questa Politica</h2>
              <p className="leading-relaxed">
                Potremmo aggiornare questa informativa sulla privacy di volta in volta. Ti informeremo di eventuali modifiche sostanziali pubblicando la nuova politica su questa pagina e aggiornando la data di "Ultimo aggiornamento".
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Processo Decisionale Automatizzato</h2>
              <p className="leading-relaxed">
                Il nostro servizio utilizza algoritmi di intelligenza artificiale per generare suggerimenti di attività. Questa funzione è puramente assistiva e non crea decisioni con effetti legali o significativi sugli utenti. Puoi scegliere di non utilizzare i suggerimenti in qualsiasi momento.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Autorità di Controllo</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Hai il diritto di presentare un reclamo all'autorità di controllo per la protezione dei dati:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Ufficio ceco per la protezione dei dati personali (ÚOOÚ)</strong></p>
                  <p className="text-sm mt-2">Pplk. Sochora 27, 170 00 Praga 7</p>
                  <p className="text-sm">Web: <a href="https://www.uoou.cz" className="text-indigo-600 hover:underline">www.uoou.cz</a></p>
                  <p className="text-sm">Email: posta@uoou.cz</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Come Esercitare i Tuoi Diritti</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Per esercitare i tuoi diritti ai sensi del GDPR (accesso ai dati, rettifica, cancellazione, portabilità, opposizione, ecc.):
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Inviaci una richiesta a <strong>support@simplestickers.app</strong></li>
                  <li>Risponderemo entro <strong>1 mese</strong> dalla ricezione della tua richiesta</li>
                  <li>Potremmo chiederti di verificare la tua identità</li>
                  <li>Il servizio è <strong>gratuito</strong> (a meno che la richiesta non sia manifestamente infondata o eccessiva)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Contattaci</h2>
              <p className="leading-relaxed">
                Se hai domande su questa informativa sulla privacy o sulle nostre pratiche relative ai dati, contattaci:
              </p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>Email:</strong> support@simplestickers.app
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  Per tutte le domande relative alla privacy, richieste di dati, supporto e altre richieste
                </p>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
